import Vue from 'vue';
import { captureMessage } from '@sentry/browser';

const state =
{
    lang: ''
};

const actions =
{
    setLanguage ({dispatch, commit}, lang)
    {
        Vue.config.lang = lang;
        Vue.http.defaults.headers.common['Accept-Language'] = lang;

        dispatch('current/updateLocale', lang, { root: true });

        try {
            localStorage.setItem('locale', lang);
        }
        catch (e) {
            captureMessage('Could not write [locale] to localStorage.', { level: 'info' });

            alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        }

        commit('SET_LANGUAGE', lang);
    }
};

const mutations =
{
    SET_LANGUAGE (state, lang) {
        state.lang = lang;
    },
};

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/meta.js